import { render, staticRenderFns } from "./BulkUploadTemplates.vue?vue&type=template&id=51976fbf&scoped=true"
import script from "./BulkUploadTemplates.vue?vue&type=script&lang=js"
export * from "./BulkUploadTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51976fbf",
  null
  
)

export default component.exports